import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MdEdit, MdDelete } from "react-icons/md";

import { productService } from "../../services/product.service";
import LogicContext from "../../Context/LogicContext";
import ProductslideScroll from "./ProductslideScroll";
import ProductPlans from "../../components/ProductPlans";
import ProductPageToogle from "../product_page_helper/ProductPageToogle";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { SetProductEdit } from "../../store/productAtom";
import Tooltip from "@mui/material/Tooltip";

const TAB_SECTION = {
  PLAN: "PLAN",
  // ADDONS: "ADDONS",
  // COUPONS: "COUPONS",
};

function ProductPage() {
  const [selectedTab, setSelectedTab] = useState(TAB_SECTION.PLAN);
  const [selectedProduct, setSelectedProduct] = useState({});
  const logicContext = useContext(LogicContext);
  const myPromiseModal = createModal(GeneralModal);
  const setProductEditable = SetProductEdit();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = "Products";
  }, []);

  const [currModuleId, currModuleName, currUserMenu] = pathname
    .split("/")
    .slice(1, 4);

  const viewItemDetails = (product) => {
    setSelectedProduct(product);
  };

  const selectTab = (section) => setSelectedTab(section);

  const modifyProduct = async () => {
    const res = await myPromiseModal({
      title: "Modify Product",
      body: "Do you want to modify the selected product?",
      showInput: false,
    });

    if (res.decision) {
      setProductEditable(selectedProduct);
    }
  };

  const addProductPlan = () => {
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/add-plan/${selectedProduct?.Product_Id}`
    );
  };

  const toogleItemStatus = (val) => {
    const status = val
      ? { Product_Status_Id: 1, Product_Status_Name: "Active", option: 5 }
      : { Product_Status_Id: 2, Product_Status_Name: "Inactive", option: 4 };

    setSelectedProduct((prev) => ({
      ...prev,
      Product_Status_Id: status.Product_Status_Id,
      Product_Status_Name: status.Product_Status_Name,
    }));

    productService
      .changeProductStatus({
        product_id: selectedProduct?.Product_Id,
        option: status.option,
      })
      .then((res) =>
        logicContext.showToast(res.data[0]["message_text"], "success")
      )
      .catch(() => {});
  };

  return (
    <section className="bg-white @container">
      <div className="flex flex-row justify-between items-center">
        <h2 className="text-xl font-bold text-gray-700">
          {selectedProduct?.Product_Name || "Select a product"}
        </h2>

        {selectedProduct?.Product_Id && (
          <div className="flex items-center space-x-2">
            <Tooltip title="Edit Product">
              <button
                onClick={modifyProduct}
                className="p-2 rounded border border-gray-200 hover:bg-gray-100 transition"
              >
                <MdEdit className="text-gray-600" />
              </button>
            </Tooltip>
            <Tooltip title="Add Plan">
              <button
                onClick={addProductPlan}
                className="p-2 rounded border border-gray-200 hover:bg-gray-100 transition"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="size-4"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </Tooltip>
          </div>
        )}
      </div>

      {selectedProduct?.Product_Id && (
        <div className="mt-2 flex items-center justify-between">
          <div className="flex items-center space-x-3 px-3 rounded-full border-[1.5px] border-gray-200">
            <span
              className={`text-sm font-medium ${
                selectedProduct.Product_Status_Id === 1
                  ? "text-green-600"
                  : "text-red-500"
              }`}
            >
              {selectedProduct.Product_Status_Name}
            </span>
            <ProductPageToogle
              toogleItemStatus={toogleItemStatus}
              val={selectedProduct.Product_Status_Id}
            />
          </div>
        </div>
      )}

      <div className="mt-4 flex flex-col lg:flex-row gap-4">
        <div className="lg:w-[300px]">
          <ProductslideScroll
            selectedProduct={selectedProduct}
            viewItemDetails={viewItemDetails}
          />
        </div>

        <div className="flex-1">
          <div className="grid grid-cols-3 gap-2">
            <div
              onClick={() => selectTab(TAB_SECTION.PLAN)}
              className={`cursor-pointer rounded-lg border px-3 py-2 text-center transition ${
                selectedTab === TAB_SECTION.PLAN
                  ? "bg-indigo-100 border-indigo-300"
                  : "bg-white"
              }`}
            >
              <div className="text-xl font-bold">
                {selectedProduct?.Total_Plans || 0}
              </div>
              <div className="text-sm text-gray-600">Plans</div>
            </div>
          </div>

          <div className="mt-2">
            {selectedTab === TAB_SECTION.PLAN && (
              <ProductPlans Product_Id={selectedProduct?.Product_Id} />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProductPage;
